import _every from 'lodash/every';

/**
 * @visibleName every
 * @since 0.22.0
 * @component
 */
export default function every(collection: Parameters<typeof _every>[0], fn: Parameters<typeof _every>[1]) {
  // Duck checking immutable.js
  if (collection && 'every' in collection && !Object.prototype.hasOwnProperty.call(collection, 'every')) {
    return (collection as any).every(fn as any);
  }

  return _every(collection, fn);
}
